module.exports = __webpack_public_path__ + "img/virtual_conference.197ba11c.svg";